import SEO from "../components/SEO";
import PageBanner from "../components/layout/PageBanner";
import Container from "../components/layout/Container";

const GDPRPolicy = () => (
  <main>
    <SEO
      title="GDPRCompliance Statement"
      description="Waterfront Cafe GDPRcompliance statement"
    />

    <PageBanner
      title="GDPR Compliance Statement"
      eyebrow="Legal"
      text="How we process and protect personal information under GDPR."
      image="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="section legal-page">
      <Container>

        <h2>GDPRCompliance Statement</h2>

        <p>Last Updated: June 2026</p>

        <p>Waterfront Cafe is committed to protecting personal information and complying with the UK General Data Protection Regulation (UK GDPR), the Data Protection Act 2018, and related privacy legislation.</p>

        <h3>Our Commitment</h3>

        <p>We process personal information responsibly, fairly, and transparently.</p>

        <p>We only collect information necessary to operate our business, manage customer enquiries and reservations, improve services, and fulfil legal obligations.</p>

        <h3>Data Protection Principles</h3>

        <p>We adhere to the following GDPRprinciples:</p>
        <ul>
          <li>Lawfulness, fairness, and transparency.</li>
          <li>Purpose limitation.</li>
          <li>Data minimisation.</li>
          <li>Accuracy.</li>
          <li>Storage limitation.</li>
          <li>Integrity and confidentiality.</li>
          <li>Accountability.</li>
        </ul>

        <h3>Information We Process</h3>

        <p>We may process:</p>
        <ul>
          <li>Customer contact details.</li>
          <li>Reservation information.</li>
          <li>Booking requests.</li>
          <li>Dietary requirement information voluntarily provided.</li>
          <li>Customer correspondence.</li>
          <li>Website analytics information.</li>
          <li>Technical website usage information.</li>
        </ul>

        <h3>Lawful Processing</h3>

        <p>Personal information is processed under one or more lawful bases:</p>
        <ul>
          <li>Consent</li>
          <li>Contractual necessity</li>
          <li>Legitimate interests</li>
          <li>Legal obligations</li>
        </ul>

        <h3>Data Security</h3>

        <p>We maintain appropriate technical and organisational safeguards designed to protect information against:</p>
        <ul>
          <li>Unauthorised access</li>
          <li>Misuse</li>
          <li>Accidental loss</li>
          <li>Alteration</li>
          <li>Disclosure</li>
          <li>Destruction</li>
        </ul>

        <h3>Individual Rights</h3>

        <p>Under GDPR, individuals have the right to:</p>
        <ul>
          <li>Access information held about them.</li>
          <li>Correct inaccurate information.</li>
          <li>Request deletion of information.</li>
          <li>Restrict processing.</li>
          <li>Object to processing.</li>
          <li>Withdraw consent.</li>
          <li>Request data portability.</li>
        </ul>

        <p>Requests will be handled in accordance with applicable legislation.</p>

        <h3>Data Retention</h3>

        <p>Personal information is retained only for as long as necessary to fulfil the purposes for which it was collected and to meet legal obligations.</p>

        <h3>Complaints</h3>

        <p>If you believe your personal information has been processed unlawfully, you have the right to lodge a complaint with the UK Information Commissioner's Office (ICO).</p>

        <p>The ICO can be contacted through its official website.</p>

        <h3>Contact</h3>

        <p>For any data protection enquiries, please contact:</p>
        <ul>
          <li>Email: info@waterfrontcafe.co.uk</li>
          <li>Telephone: +44 (0) 1491 833 732</li>
          <li>Address: A4074 Benson Waterfront, Wallingford, Oxfordshire, OX10 6SJ, United Kingdom</li>
        </ul>

      </Container>
    </section>
  </main>
);

export default GDPRPolicy;
